import { useRef } from 'react'

export default function useFollow<T>(value: T): Readonly<{ current: T }> {
	const ref = useRef(value)
	ref.current = value
	return ref
}
